<template>
    <div class="deal_index_box">
        <!-- 資金管理 -->
        <div class="deal_title">
            <div>資金管理<span>》</span>儲值╱轉入</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box" v-show="transferShow">
            <div class="deal_content_title">轉入</div>
            <div class="deal_content" v-loading="loading">
                <div class="center_box">
                    <!-- 轉入 -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <el-form-item label="*入款帳戶：">
                            <el-select class="form_select" v-model="value" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- 提示？ -->
                            <div class="hint_box">
                                <i class="el-icon-question"></i>
                                <div class="hint_text">手續費帳戶、退款帳戶、支出帳戶需申請後獨立分離</div>
                                <div class="hint_triangle"></div>
                            </div>
                        </el-form-item>
                        <el-form-item label="*轉入方式：">
                            <el-radio-group v-model="typeRadio" size="small">
                                <el-radio-button label="WEBAIM" class="type_radio"></el-radio-button>
                                <el-radio-button label="ATM" class="type_radio"></el-radio-button>
                                <el-radio-button label="超商" class="type_radio"></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="*轉入銀行：">
                            <img @click="bankImgFun('1')" :class="bankImg =='1' ?'bank_box_img bank_box_img_no1 bank_box_active ':'bank_box_img bank_box_img_no1'" src="../../../../assets/img/login/logindeal/certificates/icon_bank.png" alt="">
                            <img @click="bankImgFun('2')" :class="bankImg =='2' ?'bank_box_img bank_box_active ':'bank_box_img'" src="../../../../assets/img/login/logindeal/certificates/icon_bank.png" alt="">
                            <!-- <img @click="bankImgFun('3')" :class="bankImg =='3' ?'bank_box_img bank_box_active ':'bank_box_img'" src="../../../../assets/img/login/logindeal/certificates/icon_bank.png" alt=""> -->
                        </el-form-item>
                        <el-form-item label="*轉入金額：">
                            <el-input class="input_el" v-model="moneyInput" :placeholder="'可用餘額為 '+ moneyMax +' 元'" @blur="judgeInput()"></el-input>元
                        </el-form-item>
                        <el-form-item label="*交易密碼：">
                            <el-input class="input_pass" v-model="inputPass" placeholder="請輸入交易密碼" maxlength='6' show-password></el-input>
                            <span class="input_pass_bule" @click="forget()">忘記交易密碼?</span>
                            <div>預留資訊：<span class="input_pass_green">{{this.$store.state.reserved}}</span></div>
                        </el-form-item>
                        <el-form-item label="備註：">
                            <el-input type="textarea" :rows="6" placeholder="" v-model="textarea" class="textarea_box" resize="none"></el-input>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="primary" class="button_right" @click="dealShiftFun()">執行轉入</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <login-transfer :spanTitle="spanTitle" v-show="!transferShow" @transferShowFun="transferShowFun()"></login-transfer>
        <!-- deal_index_box -->
    </div>
</template>

<script>
import axios from 'axios';
import LoginTransfer from '@/page/login/common/LoginTransfer.vue';

export default {
    name: 'LoginDealShift',
    data() {
        return {
            form:{
                income: '1063.19',
                incomeNumber: '3',
                expenditure: '224.57',
                expenditureNumber: '1'
            },
            bankImg: '1',
            spanTitle: '轉入',
            transferShow: true,
            textarea: '',
            options: [{
            value: '1',
            label: '基本帳戶  餘額 0元'
            }],
            value: '1',
            typeRadio: 'WEBAIM',
            moneyInput: '',
            moneyMax: '0',
            moneyTF: false,
            inputPass: '',
            dateValue: '',
            paymentValue: '',
            transactionValue: '',
            loading: false,
        // return
        }
    },
    methods: {
        dealShiftFun(){
            let typeradio = '';
            // moneyInput:
            if(this.moneyInput == ''){
                this.$message({
                    showClose: true,
                    message: '請輸入金額',
                    type: 'error',
                    duration: 1000
                });
                return
            }
            // inputPass:
            if(this.inputPass == ''){
                this.$message({
                    showClose: true,
                    message: '請輸入交易密碼',
                    type: 'error',
                    duration: 1000
                });
                return
            }
            // typeRadio:
            if(this.typeRadio == 'WEBAIM'){
                typeradio = 1;
            } else if(this.typeRadio == 'ATM'){
                typeradio = 2;
            } else {
                typeradio = 3;
            }
            // loading:
            this.loading = true;
            // axios:
            axios.get(this.$store.state.axiosShiftUrl, {
                params:{
                    uid: this.$store.state.uid,
                    receipt: this.value,
                    deposit_type: typeradio,
                    deposit_bank: this.bankImg,
                    money: this.moneyInput,
                    trader_password: this.inputPass,
                    remark: this.textarea
                }
            }).then(res =>{
                this.loading = false;
                // console.log(res.data);
                if(res.data.status){
                    this.transferShow = !this.transferShow;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error',
                        duration: 1000
                    });
                }
                
            })
        },
        forget(){
            this.$router.push("/login/deal/forget");
            this.$store.commit('changeFP',"/login/deal/shift");
        },
        bankImgFun(index){
            this.bankImg = index;
        },
        transferShowFun(){
            // this.$router.go(0);
            this.transferShow = true;
            this.moneyInput = '';
            this.inputPass = '';
            this.textarea = '';
        },
        // 判斷是否正數字：
        judgeInput(){
            if(this.moneyInput != ''){
                const pattern = /\d/;
                // 判断是否数字：
                if(pattern.test(this.moneyInput)){
                    if(this.moneyInput > 0){
                        this.moneyInput = Math.round(this.moneyInput*100)/100;
                        if(this.moneyInput > this.moneyMax){
                            // 請輸入小於可用餘額的數字金額
                            this.$message({
                                showClose: true,
                                message: '請輸入小於可用餘額的數字金額',
                                type: 'error',
                                duration: 1000
                            }); 
                            this.moneyTF = false;

                        } else {
                            this.moneyTF = true;
                        }
                    } else {
                        // 請輸入大於0的數字金額
                        this.$message({
                            showClose: true,
                            message: '請輸入大於0的數字金額',
                            type: 'error',
                            duration: 1000
                        }); 
                        this.moneyTF = false;
                    }
                } else {
                    // 請輸入金額
                    this.$message({
                        showClose: true,
                        message: '請輸入金額',
                        type: 'error',
                        duration: 1000
                    });
                    this.moneyTF = false;
                }

            }
        },

    },
    components: {
        LoginTransfer
    },
    created(){

        axios.get(this.$store.state.axiosShiftUrl, {
            params:{
                uid: this.$store.state.uid,
                action: 1
            }
        }).then(res =>{
            // 0餘額, 1可用餘額
            // console.log(res.data);
            this.options[0]['label'] = '基本帳戶 餘額 ' + res.data.message[0] + ' 元';
            this.moneyMax = res.data.message[1];
        })
        
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .form_select {
        width: 240px;
    }
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .hint_box {
        font-size: 15px;
        display: inline-block;
        color: #26b5d2;
        margin-left: 8px;
        position: relative;
    }
    .hint_box:hover .hint_text {
        display: block;
    }
    .hint_box .hint_text {
        display: none;
        box-sizing: border-box;
        position: absolute;
        bottom: -12px;
        left: 6px;
        border: 1px solid #26b5d2;
        line-height: 19px;
        font-size: 11px;
        color: #777;
        width: 286px;
        padding: 0 4px;
    }
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    .input_box {
        width: 300px;
        margin-left: 10px;
    }
    .bank_box_img {
        box-sizing: border-box;
        cursor: pointer;
        margin: 0 5px;
        border: 2px solid transparent;
    }
    .bank_box_img_no1 {
        margin-left: 0px;
    }
    .bank_box_active {
        border: 2px solid #e73262;
        opacity: 1;
    }
    .input_el {
        width: 200px;
        margin-right: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_bule {
        cursor: pointer;
        margin-left: 14px;
        color: #4d80e7;
    }
    .input_pass_green {
        margin-left: 14px;
        color: #13ae22;
        margin: 6px;
    }
    .textarea_box {
        width: 350px;
    }
    .button_right {
        margin-left: 250px;
    }
</style>
